import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import BASE_URL from '../../Config';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Typography,
  Alert,
  ButtonGroup,
  Button
} from '@mui/material';

export default function EstadoPromo() {
  const { n_contrato } = useParams();
  const [promos, setPromos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const history = useHistory();
  useEffect(() => {
    const fetchPromos = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/promos/listar/${n_contrato}`);
        setPromos(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching promos:', error);
        setError(true);
        setLoading(false);
      }
    };

    fetchPromos();
  }, [n_contrato]);

  return (
    <div>
      <ButtonGroup
       variant="contained"
       aria-label="Basic button group"
       style={{
         position: "fixed",
         top: "calc(100px + 5px)",
         right: "20px",
         zIndex: "999",
         marginBottom: "50px",
       }}>
      <Button
                  style={{ marginLeft: 10 }}
                  type="button"
                  onClick={() => history.push("/homePage")}
                >
                  Volver
                </Button>
      </ButtonGroup>
      <Typography variant="h4" gutterBottom>
        Detalles del Contrato con Promoción
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Alert severity="error">Ocurrió un error al cargar los datos.</Alert>
      ) : promos.length > 0 ? (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Promo ID</TableCell>
                <TableCell>Fecha de Inicio</TableCell>
                <TableCell>Fecha de Fin</TableCell>
                <TableCell>Promo Activa</TableCell>
                <TableCell>Promo Facturada?</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {promos.map((promo) => (
                <TableRow key={promo.promo_id}>
                  <TableCell>{promo.promo_id}</TableCell>
                  <TableCell>{promo.startDate}</TableCell>
                  <TableCell>{promo.endDate}</TableCell>
                  <TableCell>{promo.isPromoActive ? 'Sí' : 'No'}</TableCell>
                  <TableCell>{promo.facturada ? 'Sí' : 'No'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Alert severity="info">No se encontraron promociones para este contrato.</Alert>
      )}
    </div>
  );
}



